import getUncompletedSections from './getUncompletedSections';
import {isDemandModification, isDemandPreparing} from "./getDemandStatus";
import {DemandValidation} from "../constants/DemandValidation";

export default (demandValidation, bzpContractNoticeStatus) => {
    if (!demandValidation || (!isDemandPreparing() && !isDemandModification()) || !bzpContractNoticeStatus) return false;
    const uncompleted = getUncompletedSections(demandValidation);
    return (uncompleted.length === 0 || (uncompleted.length === 1 && uncompleted[0] === DemandValidation.APPROVAL)) && bzpContractNoticeStatus.status !== 'NONE';
}
